import { type InvoiceFrequencyEnumKey } from 'korint-sdk';
import { useTranslation } from 'react-i18next';

export const MAX_FLEET_SIZE = 1000;

// assets/batch/{create,edit} reject more than this many items per call (@ArrayMaxSize).
export const ASSET_BATCH_LIMIT = 100;

const INVOICE_FREQUENCY_KEYS = [
  'BIENNIAL',
  'YEARLY',
  'QUARTERLY',
  'MONTHLY',
  'WEEKLY',
  'HALF_YEARLY',
] as const satisfies readonly InvoiceFrequencyEnumKey[];

export function useInvoicingFrequencyLabels(): Record<string, string> {
  const { t } = useTranslation();
  return Object.fromEntries(INVOICE_FREQUENCY_KEYS.map(k => [k, t(`invoicingFrequency.${k}`)]));
}
